import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TCIcon from '../TCIcon';
import { Button } from '../Base';

const SButton = styled(Button)`
  &&&& {
    padding: 0.4em 0.2em;
    margin-right: 0;
  }
`;

const CloseButton = props => (
  <SButton
    borderless
    inverted
    color="red"
    content={
      <span style={{ fontWeight: 400 }}>
        <TCIcon name="close" />
        ปิด
      </span>
    }
    {...props}
  />
);

export default CloseButton;
